import React from 'react';

export const TrialStatus: React.FC = () => (
  <svg width="100" height="40" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="40" rx="6" fill="#FFC63C" />
    <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#0F4A5A" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold">
      Trial
    </text>
  </svg>
)
